import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
// import Typography from "@material-ui/core/Typography";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import { ShipmentByTrackingNumber_shipmentByTrackingNumber } from "@saleor/orders/types/ShipmentByTrackingNumber";
import React from "react";

// import { FormattedMessage } from "react-intl";
import { renderCollection } from "../../../misc";

interface OrderShipmentProps {
  shipmentInfos: ShipmentByTrackingNumber_shipmentByTrackingNumber[];
}

const OrderShipment: React.FC<OrderShipmentProps> = ({ shipmentInfos }) => (
  <Card>
    <ResponsiveTable>
      <TableRow>
        <TableCell colSpan={9}>
          {/* <Typography color="textSecondary" variant="body2">
            <FormattedMessage
              defaultMessage="Shipment Details"
              description="shipment"
            />
          </Typography> */}
          <span style={{ fontSize: "16px", lineHeight: "32px" }}>
            Shipment Details
          </span>
        </TableCell>
      </TableRow>
      {shipmentInfos &&
        renderCollection(shipmentInfos, shipmentInfo => {
          const [open, setOpen] = React.useState(false);
          return (
            <>
              <TableRow>
                <TableCell colSpan={9}>
                  {/* <FormattedMessage
                  defaultMessage="Tracking Number: {trackingNumber}"
                  values={{
                    trackingNumber: (
                      <Typography color="textPrimary" variant="body2">
                        {shipmentInfo?.trackingNumber}
                      </Typography>
                    )
                  }}
                /> */}
                  <strong style={{ lineHeight: "30px" }}>
                    {" "}
                    trackingNumber: {shipmentInfo?.trackingNumber}
                  </strong>

                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpen(!open)}
                    style={{ float: "right" }}
                  >
                    {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </IconButton>
                </TableCell>
              </TableRow>

              {open && (
                <TableRow>
                  <TableCell colSpan={9}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                      <Box margin={1}>
                        {shipmentInfos &&
                          renderCollection(shipmentInfo.shipmentInfos, info => (
                            <TableRow>
                              <TableCell>{info?.time}</TableCell>
                              <TableCell>{info?.detail}</TableCell>
                              <TableCell>
                                {info?.status + ":" + info?.statusDescription}
                              </TableCell>
                            </TableRow>
                          ))}
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              )}
            </>
          );
        })}
    </ResponsiveTable>
  </Card>
);
export default OrderShipment;
